export default __webpack_public_path__ + "static/media/audubon-logo.fde3865f.png";